import React, { createContext, useContext, useEffect, useState } from "react";
import { apiClient } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("nms_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("nms_token");
    if (!token) {
      setReady(true);
      return;
    }
    apiClient
      .get("/auth/me")
      .then((r) => {
        if (r.data?.user) {
          setUser(r.data.user);
          localStorage.setItem("nms_user", JSON.stringify(r.data.user));
        }
      })
      .catch(() => {
        localStorage.removeItem("nms_token");
        localStorage.removeItem("nms_user");
        setUser(null);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (username, password) => {
    const { data } = await apiClient.post("/auth/login", { username, password });
    if (data?.token) {
      localStorage.setItem("nms_token", data.token);
      localStorage.setItem("nms_user", JSON.stringify(data.user));
      setUser(data.user);
      return data.user;
    }
    throw new Error("Login gagal");
  };

  const logout = () => {
    localStorage.removeItem("nms_token");
    localStorage.removeItem("nms_user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, ready, isAuthed: !!user }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
